/** First URL segments owned by the main Akalan app — never treat as a tenant slug. */
export const RESERVED_TENANT_SLUGS = new Set([
  'admin',
  'about',
  'blog',
  'college',
  'company',
  'contact',
  'dashboard',
  'demo',
  'for-colleges',
  'for-companies',
  'portfolio',
  'job-search',
  'jobs',
  'resume-rewrite',
  'interview',
  'invites',
  'join',
  'launch',
  'login',
  'onboarding',
  'portal',
  'privacy',
  'report',
  'session',
  'signup',
  'student',
  'terms',
  'p',
  'affiliate',
  'a',
]);

export function isReservedTenantSlug(slug: string | null | undefined): boolean {
  const normalized = slug?.trim().toLowerCase() ?? '';
  return normalized.length > 0 && RESERVED_TENANT_SLUGS.has(normalized);
}
